import usePromoSource from 'hooks/usePromoSource';
import { SanityAsset } from 'screens/Affiliate/detail/AffiliateDetail.utils';

import { useIntl } from '@skippay/core/i18n/intl';

import usePromoData from './usePromoData';

export type Output = {
	title: string;
	subtitle: string;
	promoTitle?: string;
	image: SanityAsset['fixed'] | null;
	promoSource: string | null;
};

export const usePromoContent = (): Output => {
	const promocodeData = usePromoData();

	const intl = useIntl();

	const promoSource = usePromoSource();

	const defaultContent: Output = {
		title: intl.formatMessage({
			id: 'RegistrationScreen.web.heading',
			defaultMessage: 'Vytvořte si registraci zdarma',
		}),
		subtitle: intl.formatMessage({
			id: 'RegistrationScreen.web.subheading',
			defaultMessage: 'Jeden krok k lepšímu nakupování',
		}),
		image: null,
		promoSource: null,
	};

	if (!promoSource) {
		return defaultContent;
	}

	const promoPanel = promocodeData?.data?.nodes?.find(
		(promoData) => promoData.promoSource === promoSource
	);

	if (promoPanel) {
		return {
			title: promoPanel.title,
			subtitle: promoPanel.subTitle,
			promoTitle: promoPanel.promoTitle,
			image: promoPanel.image.asset.fixed,
			promoSource: promoPanel.promoSource,
		};
	}

	return defaultContent;
};
